// extracted by mini-css-extract-plugin
export default {"cellBody":"RenderCellWithWarning_cellBody__d75zZ"};